export const ACCOUNT_TYPE = {
  CURRENT_ACCOUNT: '当座',
  SAVINGS_ACCOUNT: '普通',
  THRIFT_ACCOUNT: '貯蓄',
  OTHER: 'その他',
}
